var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"16","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M3.438 17V9m0 0V1h11.428l-3.428 4 3.428 4H3.438z","stroke":"var(--color-primary)"}}),_c('path',{attrs:{"d":"M.666 17h14","stroke":"var(--color-primary)","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }